<template>
<v-row v-if="loggedUser">
  <v-col cols="4">
    <v-form ref="addImageForm" lazy-validation>
      <v-file-input counter show-size accept="image/*;capture=camera" @change="onFileChange" ref="fileUpload"
                    :label="$t('client.account.license')" prepend-icon="mdi-camera"></v-file-input>
    </v-form>
  </v-col>
  <v-col cols="12">
    <v-simple-table v-if="loggedUser.files && loggedUser.files.length>0">
      <template v-slot:default>
        <thead>
        <tr>
          <th>{{ $t('client.location_details.file')}}</th>
          <th>Type</th>
          <th>Date</th>
          <th>{{ $t('client.location_details.download')}}</th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(file, i) in loggedUser.files" :key="i" class="py-2">
          <td>{{file.name}}</td>
          <td>{{file.type}}</td>
          <td>{{file.created |formatDateTime}}</td>
          <td><a target="_blank" :href="'/app/api/user/file?fileId='+ file.id"><v-icon class="mr-2">mdi-download</v-icon> </a></td>
        </tr>
        </tbody>
      </template>
    </v-simple-table>
  </v-col>
</v-row>
</template>


<script>

  import { mapGetters } from 'vuex';
  import { UsersApi } from '../../../shared/services/api'
  import moment from 'moment'

  export default {
    name: 'FilesPermis',
    components: {},
    data () {
      return {

      }
    },
    methods: {
      onFileChange (file) {
        console.log(file);
        if (file) {
          var formData = new FormData();
          var fileName = file.name;
          if (fileName == 'image.jpg') {
            fileName = moment().format('YYYY-MM-DD hh.mm.ss') + '.jpg'
          }
          formData.append('file', file, fileName);

          UsersApi.uploadFile(formData, "Permis").then(data => {
            //update page
            UsersApi.me().then(user => this.$store.commit('main/setLoggedUser', user));
            this.$refs.addImageForm.reset();
            // succes message
            this.$root.bar.success({ message: i18n.t('shared.uploadSuccess') })
          }).catch(error => {
            this.$root.bar.error({ message: error })
          })

        }
      }
    },
    created: function () {

    },
    computed: {
      ...mapGetters({ loggedUser: 'main/loggedUser' })
    }
  }
</script>
